import { useDispatch, useSelector } from "react-redux";
import { setSelectedColumnsAction } from "../reducers/selectedReportColumns";

const buildColumnsMap = (columns) => Object.fromEntries(columns.map(({ name, enable }) => [name, enable]));

const useSelectedColumns = (availableColumns, reportKey) => {
  const dispatch = useDispatch();

  const selectedColumns = useSelector((state) => state.selectedReportColumns?.[reportKey]) ?? buildColumnsMap(availableColumns);

  const setSelectedColumns = (newSelectedColumns) => {
    dispatch(setSelectedColumnsAction(reportKey, newSelectedColumns));
  };

  return [selectedColumns, setSelectedColumns];
};

export default useSelectedColumns;
